import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

export default function CTASection() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-100px' });

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section data-testid="cta-section" className="py-20 md:py-28 relative overflow-hidden" style={{ background: 'var(--color-surface)' }}>
      <div className="absolute inset-0 opacity-30"
        style={{ background: 'radial-gradient(ellipse at center, var(--color-glow), transparent 60%)' }}
      />
      <div className="relative max-w-4xl mx-auto px-6 md:px-12 text-center" ref={ref}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
        >
          <h2 data-testid="cta-heading" className="font-heading font-bold text-4xl sm:text-5xl tracking-tight mb-6" style={{ color: 'var(--color-text)' }}>
            Ready to Protect Your{' '}
            <span className="gradient-text">Rights?</span>
          </h2>
          <p className="font-body text-lg max-w-2xl mx-auto mb-10" style={{ color: 'var(--color-text-muted)' }}>
            Don&apos;t wait until it&apos;s too late. Get the expert legal counsel you need today.
            Our team is standing by to provide you with a comprehensive evaluation of your case.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <button
              data-testid="cta-consultation-button"
              onClick={() => scrollTo('contact')}
              className="inline-flex items-center gap-2 px-8 py-4 rounded-md text-white font-semibold transition-all duration-300 hover:shadow-[0_0_30px_rgba(6,182,212,0.4)] hover:scale-105"
              style={{ background: 'linear-gradient(135deg, var(--color-secondary), var(--color-accent))' }}
            >
              Get Your Free Evaluation Today
              <ArrowRight size={18} />
            </button>
            <a
              href="tel:+19176244469"
              data-testid="cta-call-button"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-md font-semibold border transition-all duration-300 hover:scale-105"
              style={{ borderColor: 'var(--color-border)', color: 'var(--color-text)' }}
            >
              Call (917) 624-4469
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
